"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const copy_1 = require("../icons/copy");
exports.default = copy_1.Copy;
